/* Johnson: the quote app's floating "View Quote" tab is hidden (assets/jf-quote.css), so when a shopper
   clicks "Request for quote" we open the quote popup for them once the item has been added. */
(function () {
  function openQuote() {
    var btn = document.querySelector('.omgrfq_view_quote');
    if (btn) btn.click();
  }
  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('.omgrfq-btn-add-quotes, .omgrfq-btn-quotes, .omgrfq-button');
    if (!add) return;
    /* give the app time to add the item, then open the list (skip if it already opened itself) */
    setTimeout(function () {
      var ov = document.querySelector('.omgrfq-overlay');
      var open = ov && getComputedStyle(ov).display !== 'none';
      if (!open) openQuote();
    }, 900);
  }, true);
})();